module.exports = __webpack_public_path__ + "static/img/2.b607f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/2.jpg
// module id = lieJ
// module chunks = 0